/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Tool Icon component.
 */
export const PlayIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path d="M8 5v14l11-7z" fill={iconColor} />
    </svg>
  );
};
